// Environment configuration utility
const config = {
    // API Configuration
    apiUrl: (() => {
        if (process.env.REACT_APP_API_URL) {
            return process.env.REACT_APP_API_URL;
        }

        if (process.env.REACT_APP_BACKEND_URL) {
            return `${process.env.REACT_APP_BACKEND_URL}/api`;
        }

        // Development fallback - use proxy
        return '/api';
    })(),

    // Backend URL
    backendUrl: process.env.REACT_APP_BACKEND_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : ''),

    // Frontend URL
    frontendUrl: process.env.REACT_APP_FRONTEND_URL || `http://localhost:${process.env.PORT || 8080}`,

    // Environment
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',

    // App Configuration
    appName: 'Campaign Management System',
    version: process.env.REACT_APP_VERSION || '1.0.0',

    // API Configuration
    timeout: 5000000, // 5 minutes

    // File Upload Limits
    maxFileSize: 100 * 1024 * 1024, // 100MB - increased for large CSV files
    allowedFileTypes: {
        csv: ['.csv', 'text/csv'],
        audio: ['audio/*', '.mp3', '.wav', '.m4a', '.aac']
    },

    // Debug logging
    enableDebugLogs: process.env.REACT_APP_DEBUG === 'true' && process.env.NODE_ENV === 'development'
};

// Debug logging utility
export const debugLog = (...args) => {
    if (config.enableDebugLogs) {
        console.log('[DEBUG]', ...args);
    }
};

// Environment validation
export const validateEnvironment = () => {
    const warnings = [];

    if (!process.env.REACT_APP_API_URL && !process.env.REACT_APP_BACKEND_URL) {
        warnings.push('No backend URL configured - using development proxy');
    }

    if (config.isProduction && process.env.REACT_APP_API_URL?.includes('localhost')) {
        warnings.push('Production build is using localhost API URL');
    }

    if (warnings.length > 0 && config.enableDebugLogs) {
        console.warn('[ENV WARNINGS]', warnings);
    }

    return { isValid: true, warnings };
};

// Initialize environment validation
if (typeof window !== 'undefined') {
    validateEnvironment();
}

export default config; 